declare const __API_SERVER_HOST__: string

/** 与 mcp 主域 / test 子域对齐：工作台前缀 test- 时走 test-mcp.xhey.top */
export function getMcpRegisterEnv(): 'test' | 'prod' {
  if (typeof window === 'undefined') return 'prod'
  return window.location.hostname.startsWith('test-') ? 'test' : 'prod'
}

/** 进入全部照片等页时由 BFF 代调 mcpAdmin/register，与手工联调落 Redis 一致。 */
export async function registerMcpFromAdmin(userId: string): Promise<void> {
  const uid = String(userId || '').trim()
  if (!uid) return
  const env = getMcpRegisterEnv()
  const res = await fetch(
    `${__API_SERVER_HOST__}/web/xiaohei-claw/mcp/register_from_mcp_admin`,
    {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: uid, env })
    }
  )
  if (!res.ok) {
    const err = await res.json().catch(() => ({} as Record<string, unknown>))
    console.warn('Ai照片君 MCP 注册未成功', res.status, err)
  }
}
